import { FormattedMessage } from 'react-intl';

import { SelectPropertyDropdown } from '../select-property-dropdown';
import { messages } from './messages';

import type { BarcodeWidget, PropertyOptions, BarcodeType, WidgetPropertyInput, WidgetPropertyDefinition } from '../../../config';

const options: PropertyOptions<BarcodeType> = [
  {
    name: 'code39',
    key: 'code39',
  },
  {
    name: 'code93',
    key: 'code93',
  },
  {
    name: 'code128',
    key: 'code128',
  },
  {
    name: 'datamatrix',
    key: 'datamatrix',
  },
  {
    name: 'datamatrixgs1',
    key: 'datamatrixgs1',
  },
  {
    name: 'ean13',
    key: 'ean13',
  },
  {
    name: 'ean128',
    key: 'ean128',
  },
  {
    name: 'codebar',
    key: 'codebar',
  },
  {
    name: 'qrcode',
    key: 'qrcode',
  },
  {
    name: 'inteleave25',
    key: 'inteleave25',
  },
];

const BarcodeType = (props: WidgetPropertyInput<BarcodeWidget>) => (
  <SelectPropertyDropdown options={options} property='barcodeType' {...props} />
);

export const BarcodeTypeProperty: WidgetPropertyDefinition<BarcodeWidget> = {
  id: 'barcode-type',
  label: <FormattedMessage {...messages.label} />,
  Component: BarcodeType,
};
